import ImageComponent from '../../../atoms/ImageComponent'
import chevronRight from './../../../../../../assets/Navbar/chevronRightIcon.png'
import LinkComponent from '../../../atoms/LinkComponent'
import { FC } from 'react'
import { CommonPageProps } from './types'
import MobileMenuFirstLayer from '../../../templates/MobileMenuFirstLayer/MobileMenuFirstLayer'
import { sellBuyToolsPageLinks } from './controller'


const SellBuyToolsPage: FC<CommonPageProps> = ({ handleBack, handleReset, navigateFn }) => {
    return (
        <div
            id="mob-nav-buy-sell__tools"
            className="mobile-nav-page fixed inset-y-0 right-0 z-[50] w-[91%] overflow-y-auto bg-white p-[32px] flex flex-col gap-[32px]"
        >
            <div className="flex items-center justify-between">
                <div className="">
                    <button onClick={() => handleBack()}
                        data-nav-target="mob-nav-buy-sell"
                        className="flex gap-2 items-center mob-nav-page-change-btn"
                    >
                        <span className="sr-only">Back to Sell & Buy Page</span>
                        <ImageComponent
                            className="transform -rotate-180 -mr-2"
                            source={chevronRight}
                            alt="back"
                        />
                        <div className="font-medium text-[20px]">Sell & Buy</div>
                    </button>
                </div>
                <div className="flex gap-[8px]">
                    <button onClick={() => handleReset()}
                        type="button"
                        className="-m-2.5 rounded-md p-2.5 text-gray-700 closeMobileMenuBtn"
                    >
                        <span className="sr-only">Close menu</span>
                        <svg
                            className="size-8"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            aria-hidden="true"
                            data-slot="icon"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M6 18 18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="space-y-2">
                <div className="text-[32px] font-semibold">Tools</div>
                <MobileMenuFirstLayer navigateFn={navigateFn} links={sellBuyToolsPageLinks} />
            </div>
        </div>
    )
}

export default SellBuyToolsPage